module.exports = __webpack_public_path__ + "img/process-icon4.929e72c0.png";